import { OrganizationUnitsFormType } from 'components';

export const createOrganizationUnitInitialValues: Partial<OrganizationUnitsFormType> = {};
